import React from "react";
import IElearningPage from "../../../types/IElearningPage";
import { Box, Grid } from "@mui/material";
import MediaDisplay from "../../../components/MediaDisplay";

export default function PageTopLayout({ page }: { page: IElearningPage }) {
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        {page.media && (
          <Grid item xs={12}>
            <MediaDisplay media={page.media} />
          </Grid>
        )}
        <Grid item dangerouslySetInnerHTML={{ __html: page.content }} />
      </Grid>
    </Box>
  );
}
